import {Directive, ElementRef, Output, EventEmitter, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Input() omit; // Array of elements to omit

  constructor(private _elementRef: ElementRef) {}

  @Output()
  public clickOutside = new EventEmitter();

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);

    let clickedOmitted = false;
    if (this.omit) {
      const nativeElements = this.omit.map(elem => (elem instanceof ElementRef ? elem.nativeElement : elem));

      clickedOmitted = nativeElements.some(elem => elem.contains(targetElement));
    }

    if (!clickedInside && !clickedOmitted) {
      this.clickOutside.emit(null);
    }
  }
}
